const selectedReward = {
    title: 'Example JSON',
    expectedOutput: '150000',
    initialDisplayedCode: `{
		"selectedReward": {
			"isOddsBoost": true,
			"boostedOdds": 3000,
			"outcomeIds":[100]
		},
	
	`,
    moreCode: `
	"selectedOutcomes": [{
		"id": 100,
		"odds": 1100,
		"nrOfPermutations": 0,
		"betOfferId": 1234578
	}],
	"betBuilders": [],
	"betOffers": [],
	"hasSelectedTeaser": false,
	"selectedTab": "single",
	"stakes": [{
		"stake": 1,
		"outcomeId": 100,
		"toWinInput": 100,
		"eachWaySelected": true,
		"type": "single"
	}]
}`,
};

export default selectedReward;
